import {
  ADD_TO_WISHLIST_ACTION,
  ADD_TO_WISHLIST_ACTION_LOADER,
  WISHLIST_ACTION,
  WISHLIST_ACTION_LOADER,
  CLEAR_WISHLIST_MESSAGE,
} from "../type";
const initialState = {
  loader: false,
  items: [],
  error: null,
  successMessage: null,
};
const WishlistReducer = (state = initialState, action) => {
  switch (action.type) {

    case ADD_TO_WISHLIST_ACTION_LOADER:
    case WISHLIST_ACTION_LOADER:
      return {
        ...state,
        loader: action.loader,
      };

    case ADD_TO_WISHLIST_ACTION:
    case WISHLIST_ACTION:
      return {
        ...state,
        error: action.error || null,
        successMessage: action.message || null,
      };

    case CLEAR_WISHLIST_MESSAGE:
      return {
        ...state,
        error: null,
        successMessage: null,
      };

    default:
      return state;
  }
};

export default WishlistReducer;
